import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Button, Divider } from '@material-ui/core'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import Typography from '@material-ui/core/Typography'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

import ProjectedHeadCount from './ProjectedHeadCount'
import CurrentHeadCountDetail from './CurrentHeadCountDetail/CurrentHeadCountDetail'
import CurrentHeadCountSummary from './CurrentHeadCountSummary/CurrentHeadCountSummary'
import { downloadReportImage } from '../UtilityActions'
import { hasPermissions } from '../../../../helpers/AccessControl/AccessControl'
import { useStyles } from './styles'

export default function WorkforceReport(props) {
	const classes = useStyles()

	const [openForecastDlg, setOpenForecastDlg] = useState(false)
	const [expanded, setExpanded] = useState([])

	const downloadReportTableImage = (name) => {
		downloadReportImage(name, name)
	}

	useEffect(() => {
		if (localStorage.getItem('workforce_open_reports') !== null) {
			let localWorkForceOpenReports = JSON.parse(localStorage.getItem('workforce_open_reports'))
			setExpanded(localWorkForceOpenReports)
		}
	}, [])

	const handlePanelChange = (panelName) => {
		let expandedArray = [...expanded]
		if (expandedArray.includes(panelName)) {
			expandedArray.splice(expandedArray.indexOf(panelName), 1);
		} else {
			expandedArray.push(panelName)
		}
		setExpanded(expandedArray)
		localStorage.setItem('workforce_open_reports', JSON.stringify(expandedArray))
	}

	return (
		<div className={classes.root}>
			{hasPermissions(['current_headcount_summary']) && <ExpansionPanel onChange={() => handlePanelChange('current_headcount_summary')} expanded={expanded.includes('current_headcount_summary')}>
				<ExpansionPanelSummary
					expandIcon={<ExpandMoreIcon />}
				>
					<Typography className={classes.heading}>
						Current Headcount (Summary)
					</Typography>
				</ExpansionPanelSummary>
				<ExpansionPanelDetails className={classes.expansionPanel}>
					<Button
						color="primary"
						onClick={() => downloadReportTableImage('CurrentHeadCountSummaryReport')}
					>
						Download (png)
					</Button>
					{props.reportDataChanged['WorkforceCurrentHeadCountSummary'] && 
					<span className={classes.notificationSpan}>Employees data has been updated please click the Apply button or Reset Button</span>}
					<CurrentHeadCountSummary
						fetchedFilterData={props.fetchedFilterData}
						filtersData={props.filtersData['WorkforceCurrentHeadCountSummary']}
						masterData={props.masterData}
						onDataFilterSelect={props.onDataFilterSelect}
						reportFilters={props.reportFilters['WorkforceCurrentHeadCountSummary']}
						reportData={props.reportData['WorkforceCurrentHeadCountSummary']}
						onApply={props.onApply}
						resetFilter={props.resetFilter}
						reportFiltersType={props.reportFiltersType['WorkforceCurrentHeadCountSummary']}
						reportDataChanged={props.reportDataChanged}
					/>
				</ExpansionPanelDetails>
			</ExpansionPanel>}
			{hasPermissions(['current_headcount_detail']) && <ExpansionPanel onChange={() => handlePanelChange('current_headcount_detail')} expanded={expanded.includes('current_headcount_detail')}>
				<ExpansionPanelSummary
					expandIcon={<ExpandMoreIcon />}
				>
					<Typography className={classes.heading}>
						Current Headcount Detail
					</Typography>
				</ExpansionPanelSummary>
				<ExpansionPanelDetails className={classes.expansionPanel}>
					<Button
						color="primary"
						onClick={() => downloadReportTableImage('CurrentHeadCountDetailReport')}
					>
						Download (png)
					</Button>
					{props.reportDataChanged['WorkforceCurrentHeadCountDetails'] && 
					<span className={classes.notificationSpan}>Employees data has been updated please click the Apply button or Reset Button</span>}
					<CurrentHeadCountDetail
						fetchedFilterData={props.fetchedFilterData}
						filtersData={props.filtersData['WorkforceCurrentHeadCountDetails']}
						masterData={props.masterData}
						onDataFilterSelect={props.onDataFilterSelect}
						reportFilters={props.reportFilters['WorkforceCurrentHeadCountDetails']}
						reportData={props.reportData['WorkforceCurrentHeadCountDetails']}
						onApply={props.onApply}
						resetFilter={props.resetFilter}
						reportFiltersType={props.reportFiltersType['WorkforceCurrentHeadCountDetails']}
						reportDataChanged={props.reportDataChanged}
					/>
				</ExpansionPanelDetails>
			</ExpansionPanel>}
			{hasPermissions(['projected_headcount_growth']) && <ExpansionPanel onChange={() => handlePanelChange('projected_headcount_growth')} expanded={expanded.includes('projected_headcount_growth')}>
				<ExpansionPanelSummary
					expandIcon={<ExpandMoreIcon />}
				>
					<Typography className={classes.heading}>
						Projected Headcount Growth
					</Typography>
				</ExpansionPanelSummary>
				<ExpansionPanelDetails className={classes.headCountReportPanel}>
					<Button variant="contained" color="primary" onClick={() => setOpenForecastDlg(true)}>
						Create/Update Hiring Forecast
					</Button>
					<Divider className={classes.divider}></Divider>
					<Button
						color="primary"
						onClick={() => downloadReportTableImage('ProjectedHeadCountReport')}
					>
						Download (png)
					</Button>
					{props.reportDataChanged['WorkforceProjectedHeadCountDetails'] && 
					<span className={classes.notificationSpan}>Employees data has been updated please click the Apply button or Reset Button</span>}
					<ProjectedHeadCount
						fetchedFilterData={props.fetchedFilterData}
						filtersData={props.filtersData}
						masterData={props.masterData}
						onDataFilterSelect={props.onDataFilterSelect}
						reportFilters={props.reportFilters}
						reportData={props.reportData}
						onApply={props.onApply}
						hiringForecastCreated={props.hiringForecastCreated}
						forecastOptions={props.forecastOptions}
						selectedForecasts={props.selectedForecasts}
						forecastSelectionChanged={props.forecastSelectionChanged}
						resetFilter={props.resetFilter}
						openForecastDlg={openForecastDlg}
						setOpenForecastDlg={setOpenForecastDlg}
						reportFiltersType={props.reportFiltersType}
						reportDataChanged={props.reportDataChanged}
					/>
				</ExpansionPanelDetails>
			</ExpansionPanel>}
		</div>
	)
}

WorkforceReport.propTypes = {
	masterData: PropTypes.object.isRequired,
	onDataFilterSelect: PropTypes.func.isRequired,
	reportFilters: PropTypes.object.isRequired,
	reportData: PropTypes.object.isRequired,
	onApply: PropTypes.func.isRequired,
	hiringForecastCreated: PropTypes.func.isRequired,
	forecastOptions: PropTypes.array.isRequired,
	selectedForecasts: PropTypes.object.isRequired,
	forecastSelectionChanged: PropTypes.func.isRequired,
}
